import React from "react";
import PropTypes from "prop-types";
import { BookStore, Dispatcher } from "../../flux";
import { Spinner, OnBoardingHelper } from "../../components";
import { toastUtils } from "../../../../utils/toast-utils";
const gadgetId = "chegg";

class CheggPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      url: false,
      error: false
    };
  }

  componentDidMount() {
    Jigsaw.User.createLTILaunch(
      {
        type: "chegg",
        lis_person_name_family: Fraction.User.firstName,
        isbn: this.props.isbn,
        brand_key: Fraction.Brand.jigsawBrand
      },
      response => {
        if (response.isSuccess()) {
          this.setState({ url: response.data.redirect_url });
        } else {
          this.setState({ error: true });
        }
      }
    );
  }

  render() {
    if (this.state.error) {
      return <span>{i18n.t("messages.500-error")}</span>;
    } else if (this.state.url) {
      return (
        <span>
          <div
            className="hidden-request-accessible-version"
            role="complementary"
          >
            <p tabIndex="-1">{toHTML(i18n.t("chegg.accessibility"))}</p>
          </div>
          <iframe width="100%" height="100%" src={this.state.url} />
        </span>
      );
    }
    return <Spinner />;
  }
}

CheggPanel.propTypes = {
  isbn: PropTypes.string.isRequired
};

CheggPanel.defaultProps = {};

Dispatcher.bind(Dispatcher.BOOK_OPENED, isbn => {
  if (Fraction.Brand.Chegg.forceOpen) {
    const cheggOnboarding =
      Fraction.Helpers.Users.getUserData("cheggOnboardingObject") || {};
    cheggOnboarding[isbn] = cheggOnboarding[isbn]
      ? cheggOnboarding[isbn] + 1
      : 1;
    Fraction.Helpers.Users.saveUserData(
      "cheggOnboardingObject",
      cheggOnboarding
    );
  }

  forceCheggPanelOpen(isbn);
  showCheggToast(isbn);
});

function toastOpenCheggPanel() {
  Dispatcher.emit(Dispatcher.SHOW_PANEL, gadgetId);
  toastUtils.dismiss("chegg-toast");
}

function hideCheggToast() {
  const cheggOnboarding =
    Fraction.Helpers.Users.getUserData("cheggOnboardingObject") || {};
  cheggOnboarding.hideMessage = true;
  Fraction.Helpers.Users.saveUserData("cheggOnboardingObject", cheggOnboarding);
  toastUtils.dismiss("chegg-toast");
}

function showCheggToast(isbn) {
  const book = BookStore.get(isbn);
  const cheggOnboardingObject =
    Fraction.Helpers.getUserData("cheggOnboardingObject") || {};
  if (!cheggOnboardingObject.hideMessage && isCheggAccessibleBook(isbn)) {
    toastUtils.notify({
      id: "chegg-toast",
      children: (
        <span>
          {Fraction.Brand.url === "ereader.chegg.com"
            ? i18n.t("chegg.toast-message")
            : i18n.t("chegg.toast-message-2")}
          <button
            className="noButton"
            style={{ marginLeft: "5px", fontSize: "14px" }}
            onClick={toastOpenCheggPanel}
          >
            {window.toHTML(i18n.t("chegg.click-here-to-open"))}
          </button>
        </span>
      ),
      imageUrl: book.coverURL && book.coverURL.replace(":width", "60"),
      backgroundColor: "#ECECEC",
      borderColor: "#f07d00",
      borderPosition: "left",
      maxWidth: 250,
      checkboxText: i18n.t("base.dont-show-again"),
      horizontalPosition: "right",
      dismissible: true,
      onCheckboxChange: hideCheggToast
    });
  }
}

function isCheggAccessibleBook(isbn) {
  const book = BookStore.get(isbn);
  const cheggFeatureFlag =
    book.features &&
    book.features.find(f => f.name.toLowerCase().indexOf("chegg") !== -1);
  const cheggOnly =
    cheggFeatureFlag &&
    cheggFeatureFlag.options &&
    cheggFeatureFlag.options.cheggOnly;
  const fromStore =
    book.intendedUses && book.intendedUses.indexOf("vst store") !== -1;

  if (Fraction.Brand.Chegg.enabled && cheggFeatureFlag) {
    if (Fraction.Brand.Chegg.isCheggBrand) {
      return true;
    } else {
      return Fraction.Helpers.Users.isLearner() && !cheggOnly && fromStore;
    }
  }
  return false;
}

function cheggOnboardingObject(isbn, seenOnboarding) {
  const cheggOnboarding =
    Fraction.Helpers.Users.getUserData("cheggOnboardingObject") || {};
  const timesOpened = cheggOnboarding[isbn] ? cheggOnboarding[isbn] : 1;
  if (seenOnboarding) {
    cheggOnboarding.seenOnboarding = true;
  }

  Fraction.Helpers.Users.saveUserData("cheggOnboardingObject", cheggOnboarding);
  return cheggOnboarding;
}

function forceCheggPanelOpen(isbn) {
  const book = BookStore.get(isbn);
  const cheggOnboarding = cheggOnboardingObject(isbn, null);
  const timesOpened = cheggOnboarding[book.isbn];
  const cheggAccessibleBook = isCheggAccessibleBook(isbn);
  const shouldForceCheggOpen = Fraction.Brand.Chegg.forceOpen;
  const valuesWhenToOpenPanel = [3, 7].indexOf(timesOpened) > -1;

  if (cheggAccessibleBook) {
    if (
      valuesWhenToOpenPanel &&
      (shouldForceCheggOpen || !cheggOnboarding.seenOnboarding)
    ) {
      showOnboarding(isbn);
    }
    if (valuesWhenToOpenPanel && shouldForceCheggOpen) {
      Dispatcher.emit(Dispatcher.SHOW_PANEL, gadgetId);
    }
  }
}

function showOnboarding(isbn) {
  let levels = [
    {
      title: i18n.t("chegg.stuck-on-a-problem"),
      image: "/brands/assets/chegg-onboarding-06-stuck-v3.png",
      description: (
        <span>
          <div>{toHTML(i18n.t("chegg.ts-description"))}</div>
        </span>
      )
    }
  ];

  const onboarding = Fraction.Helpers.getUserData("onboarding") || {};
  if (!onboarding["welcome"]) {
    levels = levels.concat(OnBoardingHelper._getOnboardingLevels(false));
    onboarding.welcome = Fraction.User.sessionId;
    Fraction.Helpers.saveUserData("onboarding", onboarding);
  }
  OnBoardingHelper._newOnboarding(
    "chegg-ts-onboarding",
    levels,
    false,
    $(window),
    true
  );

  const cheggOnboarding = cheggOnboardingObject(isbn, true);
}

module.exports = {
  class: CheggPanel,
  metadata: () => ({
    id: gadgetId,
    name: "Chegg Textbook Solutions",
    learnMore: false,
    launch: "// TODO",
    toggle: false,
    expanded: false,
    type: "panel",
    autoShow: false,
    enabled: isbn => isCheggAccessibleBook(isbn),
    hideInMobile: true,
    sidebar: {
      icon: "/img/chegg/chegg_tbs.svg",
      activeMethod: "fill", // 'fill' or 'highlight'
      action: () => {
        Dispatcher.emit(Dispatcher.TOGGLE_PANEL, gadgetId);
      }
    }
  })
};
